import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=98ceda28&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Editor.vue?vue&type=style&index=1&id=98ceda28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ceda28",
  null
  
)

export default component.exports